"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgTvs(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M11 34a1 1 0 100 2v-2zm12 2a1 1 0 100-2v2zm-12 0h12v-2H11v2z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("rect", { x: 3, y: 13, width: 28, height: 18, rx: 1.895, stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M9 9V6.895C9 5.848 9.848 5 10.895 5h24.21C36.152 5 37 5.848 37 6.895V20.19a1.895 1.895 0 01-1.895 1.895", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgTvs;
//# sourceMappingURL=Tvs.js.map